import { useEffect, useState } from 'react'
import { CircularProgress, Grid } from '@mui/material'

import { useNavigate } from 'react-router-dom'

import { BaseBox, PermissionsBox } from './components'
import { Check } from 'react-feather'
import { useSnackbar } from 'hooks'

import { MUI } from 'components'

import service from 'service'
import { formatters } from 'helpers'

const Callback = () => {
  const navigate = useNavigate()
  const search = new URLSearchParams(location.search)

  const [isLoading, setLoading] = useState<boolean>(false)
  const { snackbar } = useSnackbar()

  const admUser = search.get('adm_user')
  const userId = search.get('user_id')
  const storePlan = search.get('store_plan')
  const token = search.get('token')
  const code = search.get('code')
  const apiAddress = search.get('api_address')
  const storeId = search.get('store')
  const storeHost = search.get('store_host')

  useEffect(() => {
    const handleInstall = async () => {
      try {
        const data = {
          admUser,
          userId,
          storePlan,
          token,
          code,
          apiAddress,
          storeId,
          storeHost,
        }

        const response = await service.dponet.tray.install(data)

        if (response?.data?.url) {
          return window.open(
            response.data.url + '&redirect=/tray/install-feedback',
            '_self'
          )
        }

        return navigate('/')
      } catch (error) {
        return snackbar.open({
          message:
            formatters.errorMessage(error) ||
            'Ocorreu um erro. Tente novamente através do portal de aplicativos Tray',
          variant: 'error',
        })
      }
    }

    const verifyStore = async () => {
      setLoading(true)
      if (storeId) {
        const response = await service.dponet.tray.verify(storeId)
        if (response?.data?.installed) {
          return navigate('/')
        }
        handleInstall()
      } else {
        snackbar.open({
          message:
            'Loja não encontrada, tente novamente através do portal de aplicativos Tray',
          variant: 'error',
        })
        return navigate('/')
      }
    }

    verifyStore()

    //eslint-disable-next-line
  }, [])

  return (
    <BaseBox title="Ao instalar o aplicativo, iremos:">
      <PermissionsBox />
      <Grid item xs={12}>
        <MUI.Button
          variant="contained"
          color="success"
          disabled
          endIcon={isLoading ? <CircularProgress size={20} /> : <Check />}
        >
          {isLoading ? 'Instalando...' : 'Instalação concluída'}
        </MUI.Button>
      </Grid>
    </BaseBox>
  )
}

export default Callback
